import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MultiFactorAuthentication } from 'features/manageAccount/types/mfa';
import { MfaType } from '../../../../utils/mfa';

/**
 * Initial State
 */
const initialState: MultiFactorAuthentication.State = {
	currentMfaId: undefined,
	loading: false,
	isMfaEnabled: false,
	arrayOfActiveMfaTypes: undefined,
	userDefinedConfiguration: undefined,
	error: '',
	cancelFlow: false,
	currentMfaType: undefined,
	hasUserEnabledMfa: undefined,
};

/**
 * Reducers
 */
const mfaValidation = createSlice({
	name: 'mfaValidation',
	initialState,
	reducers: {
		setCurrentMfaId(state: MultiFactorAuthentication.State, action: PayloadAction<MfaType>) {
			return {
				...state,
				currentMfaId: action.payload,
			};
		},
		setLoading(state: MultiFactorAuthentication.State, action: PayloadAction<boolean>) {
			return {
				...state,
				loading: action.payload,
			};
		},
		setIsMfaEnabled(state: MultiFactorAuthentication.State, action: PayloadAction<boolean>) {
			return {
				...state,
				isMfaEnabled: action.payload,
			};
		},
		setAvailableArrayOfMfaTypes(
			state: MultiFactorAuthentication.State,
			action: PayloadAction<MultiFactorAuthentication.AvailableMfaResponse[]>
		) {
			return {
				...state,
				arrayOfActiveMfaTypes: action.payload,
			};
		},
		setMfaSetUpError(state: MultiFactorAuthentication.State, action: PayloadAction<string>) {
			return {
				...state,
				error: action.payload,
			};
		},
		setUserConfiguration(
			state: MultiFactorAuthentication.State,
			action: PayloadAction<MultiFactorAuthentication.UserDataMfaResponse[]>
		) {
			return {
				...state,
				userDefinedConfiguration: action.payload,
			};
		},
		setCancelFlow(state: MultiFactorAuthentication.State, action: PayloadAction<boolean>) {
			return {
				...state,
				cancelFlow: action.payload,
			};
		},
		setCurrentMfaType(state: MultiFactorAuthentication.State, action: PayloadAction<MfaType>) {
			return {
				...state,
				currentMfaType: action.payload,
			};
		},
	},
});

/**
 * Actions
 */
export const {
	setCurrentMfaId,
	setLoading,
	setIsMfaEnabled,
	setAvailableArrayOfMfaTypes,
	setMfaSetUpError,
	setUserConfiguration,
	setCancelFlow,
	setCurrentMfaType,
} = mfaValidation.actions;

export default mfaValidation.reducer;
